import type { OrderIssueType } from '../types/orderIssues';

export function classifyOrderIssue(
  errorMessage: string,
  errorCode?: string | null
): OrderIssueType {
  const msg = (errorMessage || '').toLowerCase();
  const code = (errorCode || '').toUpperCase();

  if (code === 'INVALID_ADDRESS' || code === 'VALIDATION_ERROR') {
    if (msg.includes('postal') || msg.includes('postcode') || msg.includes('zip')) {
      return 'postal_code_invalid';
    }
    return 'address_validation_error';
  }

  if (code === 'INCOMPLETE_ADDRESS' || msg.includes('incomplete address') || msg.includes('missing required recipient')) {
    return 'incomplete_address';
  }

  if (
    code.startsWith('POSTNL') ||
    code === 'HS_TARIFF_INVALID' ||
    code === 'SENDER_NOT_CONFIGURED' ||
    msg.includes('postnl')
  ) {
    return 'postnl_api_error';
  }

  if (
    code === 'NO_FULFILLMENT' ||
    code === 'TRACKING_USER_ERROR' ||
    code === 'TRACKING_UPDATE_FAILED' ||
    msg.includes('shopify') ||
    msg.includes('fulfillment')
  ) {
    return 'shopify_fulfillment_error';
  }

  if (msg.includes('postal code') || msg.includes('postcode') || msg.includes('zip code') || msg.includes('zip format')) {
    return 'postal_code_invalid';
  }

  if (
    msg.includes('address') ||
    msg.includes('house number') ||
    msg.includes('street') ||
    msg.includes('city') ||
    msg.includes('recipient')
  ) {
    return 'address_validation_error';
  }

  if (msg.includes('hs tariff') || msg.includes('tariff number')) {
    return 'postnl_api_error';
  }

  return 'label_generation_failed';
}
